import { addCollection } from '@iconify/react';
import circleFlags from '@iconify-json/circle-flags/icons.json';
import flagpackLang from './flagpack-lang.json';

// Flags come from this pinned package, not from the public Iconify API: the API
// follows every upstream release, and circle-flags 1.2.11 replaced several country
// flags with the same-code language flags (ie → Interlingue, ar → Arabic).
// Check those flags before bumping the version.
addCollection(circleFlags);

// The language switcher's two flags (locales/config-lang.ts), copied from
// @iconify-json/flagpack 1.2.8: the whole set would weigh 286 KB gzipped.
addCollection(flagpackLang);

// Rectangular flags do not go through Iconify at all: see FlagIcon.
